/* src/app/copyright/copyright.component.scss */
/*# sourceMappingURL=copyright.component.css.map */
